import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD0EzAe06Jf4oM1s0UA9cMw0skXv8qtjL4",
  authDomain: "cookconnorcom.firebaseapp.com",
  projectId: "cookconnorcom",
  storageBucket: "cookconnorcom.firebasestorage.app",
  messagingSenderId: "289759200792",
  appId: "1:289759200792:web:119b2d7f8aba54a115256d",
  measurementId: "G-RKDNH6E54W"
};

const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app);
export const submitQuoteRequest = httpsCallable(functions, "submitQuoteRequest");